import React from "react";
import { motion } from "framer-motion";

const WhiteBannerDivider = () => {
  return (
    <section className="bg-white text-center py-14 border-t border-neutral-200">
      <motion.div
        className="max-w-5xl mx-auto px-6"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        {/* Darker gradient title */}
        <h2 className="text-2xl md:text-3xl font-bold mb-4 leading-snug">
          <span className="text-gray-900">Bridging Innovation </span>
          <span className="bg-gradient-to-r from-[#0A2A66] via-[#154E8C] to-[#3D8FAA] bg-clip-text text-transparent">
            with Institutional Trust
          </span>
        </h2>

        {/* Supporting text */}
        <p className="text-base text-gray-600 leading-relaxed max-w-3xl mx-auto">
          QNC bridges the reliability of institutional fund structures with the efficiency of decentralized execution.
By automating performance tracking, reporting, and fee logic on-chain, QNC removes the custody and transparency barriers preventing traditional allocators from entering DeFi.
        </p>

        {/* Darker accent line */}
        <div className="mt-8 w-24 mx-auto h-[2px] bg-gradient-to-r from-[#0A2A66] via-[#154E8C] to-[#3D8FAA] rounded-full"></div>
      </motion.div>
    </section>
  );
};

export default WhiteBannerDivider;
